import { useWizard } from "react-use-wizard";
import buySteps from "../buySteps";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../..";
import FacilityTypeStep from "../../../../../../shared/wizard/steps/facilityTypeStep";

interface IWishStep_4 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  onReset: (key: TKeyOfDataWizardBuy[], data: number[]) => void;
}

const WishStep_4 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: IWishStep_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_3);
    if (data) {
      onReset(["selectedFacilityTypeIds"], [data[0]]);
    }
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_5);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      const dataFiltered = data.filter((id) => id !== selectedId);
      if (dataFiltered) {
        onChange(dataFiltered, "selectedFacilityTypeIds");
      }
    } else {
      if (data && data.length <= 2) {
        onChange([data[0], selectedId], "selectedFacilityTypeIds");
      }
    }
  };

  return (
    <div>
      <FacilityTypeStep
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        mode="repeat"
      />
    </div>
  );
};

export default WishStep_4;
